import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { ProdutoFidelidade } from '../models/produto-fidelidade';

@Injectable({
  providedIn: 'root'
})
export class FidelidadeProdutoService {

  constructor(private http: HttpClient) {

  }

  consultar() {
    return this.http.get<ProdutoFidelidade[]>(globals.apiUrl + '/api/FiProduto/Lista');
  }

  consultarComPaginacao(paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, ativo?) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);
    if (ativo !== null && ativo !== undefined) {
      parametros = parametros.set('ativo', ativo);
    }
    return this.http.get<any>(globals.apiUrl + '/api/FiProduto/ListaPag',
      {
        params: parametros
      });
  }

  consultarFotoProdutoPorId(idProduto) {

    let parametros = new HttpParams()
      .set('idProduto', idProduto);

    return this.http.get(globals.apiUrl + '/api/FiProduto/BuscarFoto',
      {
        params: parametros,
        responseType: 'blob'
      });
  }

  consultarPorId(id) {
    return this.http.get<ProdutoFidelidade>(globals.apiUrl + '/api/FiProduto/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  salvar(produto: ProdutoFidelidade) {
    return this.http.post(globals.apiUrl + '/api/FiProduto/Salvar', produto);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/FiProduto/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}
